import { customElement, property } from "lit/decorators.js";
import { html, TemplateResult } from "lit";
import { Option } from "@/components/datalist_input";
import "@/components/datalist_input";
import { DodonaElement } from "@/components/meta/dodona_element";
import { ClearInitialContentController } from "@/components/meta/clear_initial_content_controller";
import { I18n } from "@/i18n/i18n";
import { localStore } from "@/storage";

/**
 * @element d-sign-in-search-bar
 *
 * @prop {{id: number, name: string, provider_name: string, link: string}[]} institutions - The available institutions
 * @prop {string} selected_provider_id - The id of the currently selected institution's provider (Internal)
 * @prop {string} filter - The current filter value (Internal)
 */
@customElement("d-sign-in-search-bar")
export class SignInSearchBar extends DodonaElement {
    clearInitialContent = new ClearInitialContentController(this);

    @property({ type: Array })
    institutions: { id: number; name: string; provider_name: string; link: string }[];

    @property({ state: true })
    selected_provider_id: string;
    @property({ state: true })
    filter: string;

    get link(): string {
        return this.institutions.find((i) => i.id.toString() === this.selected_provider_id)?.link || "";
    }

    get options(): Option[] {
        return this.institutions.map((institution) => ({
            label: institution.name,
            value: institution.id.toString(),
            extra: institution.provider_name,
        }));
    }

    constructor() {
        super();

        const institution = localStore.getJSON<{ name?: string }>("institution");
        if (institution?.name) {
            this.filter = institution.name;
        }
    }

    handleInput(e: CustomEvent): void {
        this.selected_provider_id = e.detail.value;
        this.filter = e.detail.label;
        if (e.detail.value) {
            localStore.set("institution", JSON.stringify({ name: e.detail.label }));
        } else {
            localStore.remove("institution");
        }
    }

    handleKeydown(e: KeyboardEvent): void {
        if (e.key === "Enter" && this.selected_provider_id) {
            this.logIn();
        }
    }

    logIn(): void {
        window.location.href = this.link;
    }

    render(): TemplateResult {
        return html`
            <div class="input-group input-group-lg autocomplete">
                <d-datalist-input
                    filter="${this.filter}"
                    .options=${this.options}
                    @input=${(e) => this.handleInput(e)}
                    @keydown=${(e) => this.handleKeydown(e)}
                    placeholder="${I18n.t("js.sign_in_search_bar.institution_search")}"
                ></d-datalist-input>
                <button
                    type="button"
                    class="btn btn-filled btn-lg login-button"
                    ?disabled=${!this.selected_provider_id}
                    @click=${() => this.logIn()}
                >
                    ${I18n.t("js.sign_in_search_bar.log_in")}
                </button>
            </div>
        `;
    }
}
